import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-todo-group-filter', {
  mixins: [eventListenerMixin],

  connected() {
    this.form = this.querySelector('form');
    this.field = this.querySelector('.input-filter-value');

    this.listenTo(this.querySelector('tr-menu'), 'tao:selected', (e) => {
      const { value } = e.detail.item.dataset;
      if (this.field.value === value) return;
      this.field.value = value;
      this.sumbit();
    });
  },

  sumbit() {
    this.form.dispatchEvent(
      new Event('submit', {
        bubbles: true,
        cancelable: true,
      }),
    );
  },

  disconnected() {
    this.stopListening();
  },
});
